<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter1"><a id="page_ii"></a>Also by Mark Bowden:</p>
<p class="textcenter"><em>Doctor Dealer</em></p>
<p class="textcenter"><em>Bringing the Heat</em></p>
<p class="textcenter"><em>Black Hawk Down</em></p>
<p class="textcenter"><em>Killing Pablo</em></p>
<p class="textcenter"><em>Finders Keepers</em></p>
<p class="textcenter"><em>Road Work</em></p>
<p class="textcenter"><em>Guests of the Ayatollah</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?3ea804ac